import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdatePBXWaitCommand extends IRequestCommand<
  IUpdatePBXWaitResponse,
  ErrorDetails,
  IUpdatePBXWaitCommandParameters> {
    constructor() {
      super();
      this._commandType = CommandRequestType.PUT;
    }

  public setUrlParameters(carrierId: number, userId: number, opType: number): void {
    this.urlSections.push('carriers');
    this.urlSections.push(`${carrierId}`);
    this.urlSections.push('carrierUser');
    this.urlSections.push(`${userId}`);
    this.urlSections.push('updatePBXWait');
    this.urlSections.push(`${opType}`);
    this.composeUrl();
  }
}

export interface IUpdatePBXWaitCommandParameters {
  carrierId?: string;
  userId?: string;
}

export interface IUpdatePBXWaitResponse extends ICommandResponse {
}
